import { Clock, FileText, Minus, Package, Receipt, type LucideIcon } from "lucide-react";
import { sourceLabel } from "@/lib/documents";
import type { PositionSource } from "@/lib/types";

const ICONS: Record<PositionSource["kind"], LucideIcon> = { time: Clock, flat: Package, expense: Receipt, offer: FileText, deduction: Minus };

/** Where a position comes from: „5 Std × 115 €“, „Ausgabe · Fly.io“, …; manual positions show none. */
export function SourceChip({ source, offerNumber }: { source: PositionSource | null; offerNumber?: string | null }) {
  const label = sourceLabel(source, offerNumber ?? null);
  if (!source || !label) return null;
  const Icon = ICONS[source.kind];
  return (
    <span className="inline-flex h-5.5 max-w-48 shrink-0 items-center gap-1.5 rounded-full bg-muted px-2 text-xs text-muted-foreground" title={label}>
      <Icon aria-hidden className="size-3 shrink-0" />
      <span className="truncate">{label}</span>
    </span>
  );
}
